<template>
	<b-card class="object-card"
	        header-tag="header"
            footer-tag="footer">
		<div slot="header">
			<a :href="objectviewUrl">
				<div :style="`background-image: url(${imagePath});`"
				     class="image">
				</div>
			</a>
			<div v-if="!markedForDeletion" class="checkbox_">
				<b-form-checkbox class="_input"
				                 plain
				                 :checked="isChecked"
				                 @change="handleCheckClick(objectId, $event)">
				</b-form-checkbox>
			</div>
		</div>
		<div slot="footer">
			<erco-dropdown v-if="isVisitable"
			               size="sm"
			               :items="actionSelectionItems"
			               label="Ansehen"
			               :useLabelInline="true"
			               @change="handleActionSelectionChange">
			</erco-dropdown>

			<erco-status-badge class="badge float-right" :status="computedStatus"></erco-status-badge>
		</div>

		<div class="body">
			<h4 class="card-title font-weight-bold">{{title}}</h4>
			<p class="card-text">{{type}}</p>
			<div class="cms-structure-info">
				<div class="_item">{{ category }}</div>
				<div class="_item">{{ specification }}</div>
				<div class="_item">{{ genus }}</div>
			</div>
			<div class="meta">
				<!--
				<time class="time text-muted" :datetime="dateTime">{{clearDateTime}}</time>
				-->
				<div class="time-wrapper">
					<span class="time -online">
						<span class="pictogram"></span>
						<time v-if="clearPublishDateTime"
						      class="text-muted"
						      :datetime="publishDateTime">{{clearPublishDateTime}}</time>
						<span v-else class="text-muted"></span>
					</span>
					<span class="time -offline">
						<span class="pictogram"></span>
						<time v-if="clearOfflineDateTime"
						      class="text-muted"
						      :datetime="offlineDateTime">{{clearOfflineDateTime}}</time>
						<span v-else class="text-muted"></span>
					</span>
				</div>

				<span class="objectid text-muted">{{objectId}}</span>
			</div>
		</div>
    </b-card>
</template>
<script>

import moment from 'moment';

import Const from '@/constants';

import ErcoStatusBadge from '@/components/atoms/ErcoStatusBadge';
import ErcoDropdown from '@/components/molecules/ErcoDropdown';

export default {
	name: 'ErcoObjectCardMolecule',
	data() {
		return {
			innerIsChecked: null,
			innerStatus: null,
		};
	},
	props: {
		title: {
			type: String,
			default: 'Kein Titel',
			required: true,
		},
		type: {
			type: String,
			default: 'Unbekannter Typ',
			required: true,
		},
		imageSrc: {
			default: 'http://placehold.it/320x180',
			required: false,
		},
		publishdate: {
			type: String,
			default: '01.01.1970',
		},
		offlinedate: {
			type: String,
			defaukt: '01.01.1970',
		},
		date: {
			type: String,
			default: '01.01.1970',
			required: true,
		},
		objectId: {
			type: String,
			default: '0',
			required: true,
		},
		status: {
			type: String,
			default: 'unknown',
			required: true,
		},
		onlineUrl: {
			type: String,
			default: '',
		},
		previewUrl: {
			type: String,
			default: '',
		},
		isProductive: {
			type: Boolean,
			default: false,
		},
		checked: {
			type: Boolean,
			default: false,
		},
		category: {
			type: String,
			default: '',
		},
		specification: {
			type: String,
			default: '',
		},
		genus: {
			type: String,
			default: '',
		},
	},
	components: {
		ErcoStatusBadge,
		ErcoDropdown,
	},
	computed: {
		computedStatus() {
			const status = this.innerStatus || this.status;

			return (status === 'online' && !this.isProductive) ? 'preview' : status;
		},
		publishDateTime() {
			return moment(this.publishdate, Const.DATETIMEFORMAT);
		},
		offlineDateTime() {
			return moment(this.offlinedate, Const.DATETIMEFORMAT);
		},
		dateTime() {
			return this.date && moment(this.publishdate, Const.DATETIMEFORMAT).toDate();
		},
		clearDateTime() {
			return this.dateTime && moment(this.dateTime).format(Const.DATETIMEFORMATDEST);
		},
		numDateTime() {
			return this.dateTime && moment(this.dateTime).format('YYYYMMDD');
		},
		clearPublishDateTime() {
			if (!this.publishDateTime.isValid()) {
				return '';
			}
			const notPlanedMomentDate = moment(Const.NOTPLANNEDDATE, Const.DATETIMEFORMAT);
			if (this.publishDateTime.isValid() &&
			    (this.publishDateTime.format(Const.DATEFORMATDEST) ===
			      notPlanedMomentDate.format(Const.DATEFORMATDEST))) {
				return 'Nicht geplant';
			}
			return this.publishDateTime.format(Const.DATETIMEFORMATDEST);
		},
		clearOfflineDateTime() {
			if (!this.offlineDateTime.isValid()) {
				return '';
			}
			const notPlanedMomentDate = moment(Const.NOTPLANNEDDATE, Const.DATETIMEFORMAT);
			if (this.offlineDateTime.isValid() &&
			    (this.offlineDateTime.format(Const.DATEFORMATDEST) ===
			      notPlanedMomentDate.format(Const.DATEFORMATDEST))) {
				return 'Nicht geplant';
			}
			return this.offlineDateTime.format(Const.DATETIMEFORMATDEST);
		},
		imagePath() {
			if (this.imageSrc !== null) {
				return `${process.env.IMG_SERVER}/system/images/web/${this.imageSrc}`;
			}
			return process.env.PLACEHOLDER_IMAGE_URL;
		},
		isChecked: {
			get() {
				return (typeof this.innerIsChecked === 'boolean') ? this.innerIsChecked : this.checked;
			},
			set(checked) {
				this.innerIsChecked = checked;
			},
		},
		markedForDeletion() {
			return this.computedStatus === 'löschmarkiert'; /* TODO: 'löschmarkiert' auslagern */
		},
		objectViewUrlForObject() {
			return `/#/objectview/${this.objectId}`;
		},
		objectviewUrl() {
			const host = `${window.location.protocol}//${window.location.host}`;
			return `${host}${this.objectViewUrlForObject}`;
		},
		actionSelectionItems() {
			const selectionItems = [];

			if (this.isVisitable) {
				selectionItems.push({ text: 'Preview ansehen', value: 'preview' });
			}

			if (this.isVisitable && this.isProductive) {
				selectionItems.push({ text: 'Online ansehen', value: 'online' });
			}

			return selectionItems;
		},

		isVisitable() {
			return !!this.previewUrl;
		},
	},

	methods: {
		formatDateTime(value) {
			return `0${value}`.slice(-2);
		},

		handleActionSelectionChange(selectionInfo) {
			switch (selectionInfo.currentValue) {
				case 'preview':
					window.open(this.previewUrl);
					break;
				case 'online':
					window.open(this.onlineUrl);
					break;
				default:
			}
		},

		handleCheckClick(objID, checked) {
			const action = {
				type: '',
				objID: parseInt(objID, 10),
			};

			action.type = (checked) ? 'add' : 'remove';
			this.$store.dispatch('handleObjectSelection', action);
		},
	},

	watch: {
		checked(newChecked) {
			this.innerIsChecked = newChecked;
		},
		status(newStatus) {
			this.innerStatus = newStatus;
		},
	},
};
</script>

<style lang="scss">
	@import "~bootstrap/scss/_variables.scss";

	.object-card {
		flex: 1;
		margin-bottom: 1rem;
		@media (min-width: map-get($grid-breakpoints, sm)) {
			margin-bottom: $grid-gutter-width-base / 2;
		}

		.card-block {
			display: flex;
			flex-direction: column;

			& > .body {
				display: flex;
				flex-direction: column;
				flex: 1;

				& > .card-title {
					font-size: 1rem;
					flex: 1;
				}

				& > .card-text {
					min-height: 1.3rem;
					flex: 1;
				}

				& > .cms-structure-info {
					font-size: 0.8rem;
					margin-bottom: 0.5rem;
					flex: 0 1;

					& > ._item {
						color: rgba(41, 43, 44, 0.6);

						&:not(:first-child) {
							margin-top: 0.1rem;
						}

						&:nth-child(n+2) {
							margin-left: 1.2rem;
							position: relative;

							&:before {
								content: '';
								position: absolute;
								width: 7px;
								height: 7px;
								border: 1px solid rgba(41, 43, 44, 0.6);
								border-top: 0;
								border-right: 0;
								margin-left: -0.8rem;
								top: 0.2rem;
							}
						}

						&:nth-child(3) {
							margin-left: 1.2rem * 2;
						}
					}
				}

				& > .meta {
					flex: 0 1 auto;
				}
			}
		}
		.card-footer {
			& .badge {
				margin-top: 0.6rem;
			}
		}
		.card-header {
			padding: 0;

			.image {
				cursor: pointer;
				padding-bottom: 66.666%; /* % of width, defines aspect ratio */
				background-repeat: no-repeat;
				background-position: center center;
				background-size: cover;
				border-bottom: 1px $gray-lighter solid;
				position:relative;
				width: 100%;
			}
			.checkbox_ {
				position: absolute;
				top: 5px;
				right: 10px;
			}
		}
		.objectid {
			text-align: right;
			display: block;
		}
		.time {
			display: block;
		}
		.time, .objectid {
			font-size: 0.8rem;
		}

		.time-wrapper {
			margin-top: 0.5rem;

			& > .time {

				& > .pictogram {
					&:before {
						content: '';
						width: 0px;
						height: 0px;
						border-style: solid;
						border-width: 3px;
						border-color: #5cb85c;
						border-radius: 3px;
						display: inline-block;
						vertical-align: middle;
						margin-right: 5px;
						transform: rotate(90deg);
						margin-bottom: 3px;
					}
				}

				&.-offline {
					& > .pictogram {
						&:before {
							transform: rotate(270deg);
							border-color: #d9534f;
						}
					}
				}
			}
		}

	}
</style>




// WEBPACK FOOTER //
// ErcoObjectCard.vue?42b8b812